import { Component, DestroyRef, ViewChild, inject, Inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ServicesService } from 'src/services/services.service';
import { MatSort } from '@angular/material/sort';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface typeData {
  so_id: any;
  data: any;
}

export interface typeElement {
  so_id: string;
  company_name: string;
  owner_name: string;
  owner_number: any;
  type: string;
  product_count: string;
  action: any;
}

@Component({
  selector: 'app-stall-catalogues-list',
  templateUrl: './stall-catalogues-list.component.html',
  styleUrls: ['./stall-catalogues-list.component.scss']
})
export class StallCataloguesListComponent {
  displayedColumns: string[] = [
    'so_id',
    'company_name',
    'owner_name',
    'owner_number',
    'type',
    'product_count',
    'action',
  ];

  ELEMENT_DATA: typeElement[] = [];
  event_result: any;

  private destoryRef = inject(DestroyRef);

  dataSource = new MatTableDataSource<typeElement>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private service: ServicesService,
    private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
  ) { }

  ngAfterViewInit() {
    this.getAPI();
    this.dataSource.paginator = this.paginator;
  }


  Go(mobile: any) {
    var user_id

    this.service.get_user_by_mobile(mobile).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
      (data: any) => {
        user_id = data.data[0].user_id

        console.log(user_id);

        this.service.login_otp(mobile).subscribe(
          (data: any) => {
            if (data.flag == true) {
              const Login_Data = data.role;

              if (Login_Data === 'superadmin') {
                sessionStorage.setItem('User', 'superadmin');
                sessionStorage.setItem('User_ID', data.user_id);
                this.router.navigateByUrl('/admin/Dashboard');
              } else if (Login_Data === 'admin' || Login_Data === 'subadmin' || Login_Data === "stallowner" || Login_Data === "user") {
                sessionStorage.setItem('User', Login_Data);
                sessionStorage.setItem('User_ID', data.user_id);
                // this.router.navigateByUrl('/admin/Dashboard');

                const url = this.router.serializeUrl(
                  this.router.createUrlTree(['/admin/Dashboard'], {
                    queryParams: { User_ID: data.user_id, User: Login_Data }
                  })
                );

                const basePath = window.location.pathname.split('/')[1];

                window.open(
                  `${window.location.origin}/${basePath}#${url}`,
                  '_blank'
                );
              } else {
                alert(data.msg);
              }
            } else {
              alert(data.msg);
            }
          },
          (error: any) => {
            // Handle the error scenario
            console.error('Login request failed:', error);
            alert('Login failed: ' + (error.message || 'Unknown error'));
          });


      },
      error => {
        this.toastr.error('Failed to load users');
      }
    );

    return;


  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getAPI() {
    this.ELEMENT_DATA = [];
    this.spinner.show();
    this.service.get_stall_and_catalogues().pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      (data: any) => {
        this.event_result = data.data
        for (const item of this.event_result) {
          this.ELEMENT_DATA.push({
            so_id: item.so_id,
            company_name: item.company_name,
            owner_name: item.owner_name,
            owner_number: item.owner_number,
            type: item.type,
            product_count: item.product_count,
            action: item.so_id
          });
          this.spinner.hide();
        }
        this.dataSource = new MatTableDataSource<typeElement>(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }
}
